module.exports = __webpack_public_path__ + "static/media/icon-create.937d71dd.svg";